import { message } from 'antd';

import TokenHelper from '../../utils/token';
import { TAction } from '../store';

type TEnrichToken = {
    '@context': string;
    '@id': string;
    '@type': string;
    id: number;
    partnerId: string | null;
    token: string;
};

type PartnerTypes = {
    partnerEnrichToken: (data: {
        anonToken?: string | null;
        needToSave?: boolean;
    }) => TAction<Promise<string | null>>;
};

export const PartnerActions: PartnerTypes = {
    partnerEnrichToken({ anonToken, needToSave = true }) {
        return async (_, getState, { httpClientServices, services }) => {
            const { info } = getState().company;

            const partnerId = info?.partnerId ?? localStorage.getItem('partnerId');

            if (partnerId) {
                try {
                    const headers: { Authorization?: string } = {};
                    if (!!anonToken) {
                        headers.Authorization = `Bearer ${anonToken}`;
                    }

                    const { data } = await httpClientServices
                        .getClient('partner')
                        .post<TEnrichToken>(
                            services.partner.enrichToken,
                            { partnerId: partnerId },
                            { headers },
                        );

                    if (needToSave) {
                        TokenHelper.setTokens({ token: data.token });
                    }

                    return data.token;
                } catch (e) {
                    if (e?.response && e?.response?.status !== 404) {
                        message.error(e?.message);
                    }
                    TokenHelper.cleanTokens();

                    return null;
                }
            }

            return null;
        };
    },
};
